/**
 * <s-copy-code data-code="WELCOME10"> — Copies a discount code to the clipboard.
 *
 * Required child markup:
 *   button[commandfor=<this id>][command="--copy"] — Copies data-code.
 *   [data-copy-label] — Text swapped to data-copied-label for 2 seconds after copying.
 */
class CopyCode extends HTMLElement {
  #timer = null;

  connectedCallback() {
    this.addEventListener('command', this.#handleCommand);
  }

  disconnectedCallback() {
    this.removeEventListener('command', this.#handleCommand);
    clearTimeout(this.#timer);
  }

  #handleCommand = async (event) => {
    if (event.command !== '--copy') return;
    const code = this.dataset.code || '';
    if (!code) return;
    try {
      await navigator.clipboard.writeText(code);
    } catch {
      return;
    }
    const label = this.querySelector('[data-copy-label]');
    if (!label) return;
    const original = label.dataset.defaultLabel || label.textContent;
    label.dataset.defaultLabel = original;
    label.textContent = this.dataset.copiedLabel || original;
    clearTimeout(this.#timer);
    this.#timer = setTimeout(() => {
      label.textContent = original;
    }, 2000);
  };
}

if (!customElements.get('s-copy-code')) {
  customElements.define('s-copy-code', CopyCode);
}
